// extracted by mini-css-extract-plugin
export default {"callbackTitle":"CallbackPage_callbackTitle__ftOOT","authErrorBlock":"CallbackPage_authErrorBlock__YE68q","loginButton":"CallbackPage_loginButton__ByyrZ"};